import { useCallback } from "react";

import BoardViewToggleView from "./BoardViewToggleView";

import type { BoardViewMode } from "@/features/player-kanban/types/types";

/**
 * Props for BoardViewToggle — the Kanban ⇄ Table renderer switch (SE-5491).
 * @property value - The renderer currently mounted on the board
 * @property onChange - Fired with the newly selected renderer
 */
export interface BoardViewToggleProps {
  value: BoardViewMode;
  onChange: (mode: BoardViewMode) => void;
}

/**
 * Container for BoardViewToggle — binds the two segment presses to `onChange`.
 * @remarks
 * The selected mode is owned by MainContainer (it decides which renderer
 * mounts), so this control is fully controlled and holds no state of its own.
 * @param props - Component props
 * @param props.value - The renderer currently mounted on the board
 * @param props.onChange - Fired with the newly selected renderer
 */
const BoardViewToggleContainer = ({
  value,
  onChange,
}: BoardViewToggleProps) => {
  const handleSelectKanban = useCallback(() => onChange("kanban"), [onChange]);
  const handleSelectTable = useCallback(() => onChange("table"), [onChange]);

  return (
    <BoardViewToggleView
      value={value}
      onSelectKanban={handleSelectKanban}
      onSelectTable={handleSelectTable}
    />
  );
};

BoardViewToggleContainer.displayName = "BoardViewToggleContainer";

export default BoardViewToggleContainer;
